import { LocationOnOutlined } from "@mui/icons-material";

const LocationOnOutlinedIcon = () => (
  <LocationOnOutlined />
);

export default LocationOnOutlinedIcon;